import { HttpErrorResponse } from "@angular/common/http";
import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from "@angular/core";
import { ToastrService } from "ngx-toastr";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { GlobalComponent } from "src/app/global/global.component";
import { employeeOnboardBO, functionpermission, PageNavigateBo, SendToClientBO, SendToEmployeeBO, SendToUserBO } from "./employee-agreement.model";
import { EmployeeAgreementService } from "./employee-agreement.service";
import { DocumentComponent } from "./document/document.component";

@Component({
  selector: "app-employee-agreement",
  templateUrl: "./employee-agreement.component.html",
  styleUrls: ["./employee-agreement.component.scss"],
})
export class EmployeeAgreementComponent implements OnInit {
  private onDestroy$: Subject<void> = new Subject<void>();
  Employeepage: string = "document";
  PageViewCreateOrEdit: PageNavigateBo = new PageNavigateBo();
  enableTab: boolean;
  @Input() employeeBO = new employeeOnboardBO();
  @Output() dataEmitFromOnboard = new EventEmitter<employeeOnboardBO>();
  @ViewChild(DocumentComponent) childComponent: DocumentComponent;

  sendtoemployer=new SendToClientBO();
  sendtoemployee=new SendToEmployeeBO();  
  fp:functionpermission=new functionpermission()
  constructor(
    public agreementService: EmployeeAgreementService,
    public global: GlobalComponent,
    public toastService:ToastrService
  ) {
    this.global.checkforlogout();
  }

  ngOnInit(): void {
    this.MoveToNextPage(this.Employeepage);
    this.employeeBO.add = true;
    this.enableTab = this.agreementService.enableDoc;
    this.getpermission();
  }
  MoveToNextPage(Jobseekerpagename: string) {
    this.Employeepage = Jobseekerpagename;
  }
  dataEmitfromChild(value) {
    this.Employeepage = value.Jobseekerpagename;
    this.PageViewCreateOrEdit = value;
    if(value.close == true) {
      this.backToOnboardingList();
    }
  }
  backToOnboardingList() {
    this.employeeBO.edit = false;
    this.employeeBO.print = false;
   this.dataEmitFromOnboard.emit(this.employeeBO);
    this.global.employeetoAgreementEmit = false;
  }

  PrintAllDocument() {
   this.childComponent.GetEmpOnboardDeatalis("")
  }

  getpermission() {
    if (this.global.LoginUserType.toUpperCase() != 'ONBOARD' && (this.global.globalAgencyId!=null&&this.global.globalAgencyId!=undefined&&this.global.globalAgencyId!='')) {
    let params = new URLSearchParams();
    params.append("pagecode", "Client");
    params.append("roleId", this.global.roleId);
    params.append("agencyId", this.global.globalAgencyId)
    this.agreementService.getpermission(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {

      if (data != null) {
        this.fp = data;

      }
      else {
        this.fp = new functionpermission();
      }
    },
      (err: HttpErrorResponse) => {
        this.fp = new functionpermission();
      })
  }
}


}
